import React from 'react';
import { TextField, MenuItem, Stack, FormControlLabel, Checkbox } from '@mui/material';
import { AddressType } from '../../../../../../services/RegistrationService/registrationSlice';

interface AddressTypeOption {
  value: string;
  name: string;
}

interface AddressFormFieldsProps {
  formData: AddressType;
  availableAddressTypes: AddressTypeOption[];
  isLoading: boolean;
  onFieldChange: (field: keyof AddressType) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddressFormFields: React.FC<AddressFormFieldsProps> = ({
  formData,
  availableAddressTypes,
  isLoading,
  onFieldChange,
}) => (
  <Stack spacing={3}>
    {/* Address Type */}
    <TextField
      select
      label="Address Type"
      value={formData.addressType}
      onChange={onFieldChange('addressType')}
      size="small"
      fullWidth
      disabled={isLoading}
      required
    >
      <MenuItem value="">Select Address Type</MenuItem>
      {availableAddressTypes.map((type) => (
        <MenuItem key={type.value} value={type.value}>
          {type.name}
        </MenuItem>
      ))}
    </TextField>

    {/* Street Address */}
    <TextField
      label="Street Address"
      value={formData.street}
      onChange={onFieldChange('street')}
      size="small"
      fullWidth
      required
    />

    {/* Street Address 2 */}
    <TextField
      label="Street Address 2 (Optional)"
      value={formData.street2}
      onChange={onFieldChange('street2')}
      size="small"
      fullWidth
    />

    {/* City, State, Zip */}
    <Stack direction="row" spacing={2}>
      <TextField
        label="City"
        value={formData.city}
        onChange={onFieldChange('city')}
        size="small"
        fullWidth
        required
      />
      <TextField
        label="State"
        value={formData.state}
        onChange={onFieldChange('state')}
        size="small"
        sx={{ minWidth: 120 }}
        required
      />
      <TextField
        label="ZIP Code"
        value={formData.zip}
        onChange={onFieldChange('zip')}
        size="small"
        sx={{ minWidth: 120 }}
        required
      />
    </Stack>

    {/* Preferred Address */}
    <FormControlLabel
      control={
        <Checkbox
          checked={formData.isPreferred}
          onChange={onFieldChange('isPreferred')}
          color="primary"
        />
      }
      label="Set as preferred address"
    />
  </Stack>
);
